if (!window.__exploreStoriesSlick) {
  window.__exploreStoriesSlick = true;

  const prevIcon = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M12.2 4.2 6.4 10l5.8 5.8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const nextIcon = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M7.8 4.2 13.6 10l-5.8 5.8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const perView = () => {
    const width = window.innerWidth;
    if (width <= 749) return 1;
    if (width <= 1199) return 2;
    return 3;
  };

  const realSlides = (track) => track.querySelectorAll('.explore-stories__slide:not(.slick-cloned)');

  const pad = (value) => String(value).padStart(2, '0');

  const hideClones = (track) => {
    track.querySelectorAll('.slick-cloned').forEach((slide) => {
      slide.setAttribute('aria-hidden', 'true');
      slide.inert = true;
    });
  };

  const mount = (section) => {
    const slider = section.querySelector('[data-explore-stories]');
    const track = section.querySelector('[data-track]');
    if (!slider || !track || !window.jQuery || !window.jQuery.fn.slick) return;
    if (slider.dataset.bound === 'true') {
      slider._exploreStoriesSync?.();
      return;
    }

    slider.dataset.bound = 'true';
    const $track = window.jQuery(track);
    const arrowsDesktop = slider.querySelector('[data-arrows]');
    const arrowsMobile = slider.querySelector('[data-arrows-mobile]');
    const arrowHost = () => (window.innerWidth <= 749 ? arrowsMobile : arrowsDesktop) || arrowsDesktop;
    const dots = slider.querySelector('[data-dots]');
    const range = slider.querySelector('[data-range]');
    const note = slider.querySelector('[data-slider-note]');
    const prevLabel = slider.dataset.prevLabel || 'Previous';
    const nextLabel = slider.dataset.nextLabel || 'Next';
    let currentShow = 0;

    const setCarousel = (active) => {
      slider.classList.toggle('is-slider', active);
      if (active) {
        slider.setAttribute('role', 'region');
        slider.setAttribute('aria-roledescription', 'carousel');
        note?.removeAttribute('hidden');
      } else {
        slider.removeAttribute('role');
        slider.removeAttribute('aria-roledescription');
        note?.setAttribute('hidden', '');
      }
    };

    const updateRange = (show, current) => {
      if (!range) return;
      const total = realSlides(track).length;
      if (!total) return;
      const start = current + 1;
      const end = Math.min(total, current + show);
      const totalHtml = `<span total>/ ${pad(total)}</span>`;
      range.innerHTML = start === end
        ? `${pad(start)} ${totalHtml}`
        : `${pad(start)} - ${pad(end)} ${totalHtml}`;
    };

    const destroy = () => {
      if ($track.hasClass('slick-initialized')) $track.slick('unslick');
      setCarousel(false);
    };

    const sync = () => {
      if (!track.isConnected) {
        window.removeEventListener('resize', onResize);
        return;
      }
      const show = perView();
      const count = realSlides(track).length;
      if (count <= show) {
        destroy();
        currentShow = show;
        updateRange(show, 0);
        return;
      }
      if ($track.hasClass('slick-initialized') && currentShow === show) {
        hideClones(track);
        return;
      }
      if ($track.hasClass('slick-initialized')) $track.slick('unslick');
      currentShow = show;
      setCarousel(true);
      const host = arrowHost();
      $track.slick({
        infinite: show === 1,
        draggable: true,
        slidesToShow: show,
        slidesToScroll: 1,
        autoplay: false,
        arrows: Boolean(host),
        dots: Boolean(dots),
        adaptiveHeight: false,
        accessibility: true,
        appendArrows: host || undefined,
        appendDots: dots || undefined,
        prevArrow: `<button type="button" class="explore-stories__arrow slick-prev" aria-label="${prevLabel}">${prevIcon}</button>`,
        nextArrow: `<button type="button" class="explore-stories__arrow slick-next" aria-label="${nextLabel}">${nextIcon}</button>`,
        customPaging: (_slick, index) => `<button type="button" aria-label="Go to slide ${index + 1} of ${count}">${index + 1}</button>`,
      });
      hideClones(track);
      updateRange(show, 0);
    };

    const onResize = () => {
      window.clearTimeout(slider.resizeTimer);
      slider.resizeTimer = window.setTimeout(sync, 150);
    };

    $track.on('init afterChange', (_event, slick, currentSlide) => {
      const current = typeof currentSlide === 'number' ? currentSlide : slick.currentSlide || 0;
      hideClones(track);
      updateRange(slick.options.slidesToShow, current);
    });
    slider._exploreStoriesSync = sync;
    sync();
    window.addEventListener('resize', onResize);
  };

  const boot = () => {
    if (!window.jQuery?.fn?.slick) return;
    document.querySelectorAll('.section-explore-stories').forEach(mount);
  };

  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  if (document.readyState !== 'loading' && window.jQuery?.fn?.slick) boot();

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.('.section-explore-stories');
    if (section) mount(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const track = event.target.querySelector?.('[data-track]');
    if (track && window.jQuery?.(track).hasClass('slick-initialized')) {
      window.jQuery(track).slick('unslick');
    }
  });
}
